module.exports = __webpack_public_path__ + "static/media/sopt27ru.b6af7950.pdf";